import React from "react";
import { Card, Row } from "react-bootstrap";
import { BsFillExclamationDiamondFill } from "react-icons/bs";

const ErrorCard = (props) => {

    return (
        <Row className="mb-5">
            <Card border="danger" className="shadow-lg text-center" style={{ border: "2px solid" }}>
                <Card.Body>
                    {props.status ? (
                        <Card.Title>{props.status}</Card.Title>
                    ) : null}
                    <h1 className="text-danger"><BsFillExclamationDiamondFill /></h1>
                    <p className="mt-4">{props.error}</p>
                </Card.Body>
            </Card>
        </Row>
    )
}
export default ErrorCard;